import playerIcon from 'assets/images/players-icon.png';
import location from 'assets/images/powerzone-map.png';
import logoImage from 'assets/images/AmrutCup.png';
import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { Card, CardImg, CardText, CardTitle } from 'reactstrap';
import './Home.css';
import constants from '../../config/constants';



const Home = () => (
  <div className="content" style={{textAlign: "center"}}>
    {/* <MyTable /> */}
    {/* <img src={logoImage} alt="logo" className="logo" /> */}
    {/* <h5>4 Mandirs, 39 Teams, 315 Players</h5> */}

    
    
    <div className="container-fluid home-info" >
      <div className="home-info-logo">        
                <img src={logoImage} alt={constants.tournament+" "+new Date().getFullYear()} width="25%" className="home-info-logo"/>               
         </div>
         <div className="home-info-text">
          <Grid>
            <Row>              
              <i className="pe-7s-map-marker"></i> <a href="https://goo.gl/maps/bbW9wcvc7Cg2aSuDA">BAPS Swaminarayan Mandir, Edison</a>
            </Row>            
            {/* <Row>              
            <i className="pe-7s-date"></i>  March 25 and March 26
            </Row>             */}
            <Row>              
            <i className="pe-7s-user"></i>Age Limit : 18 to 80
            </Row>            
            {/* <Row>              
            <i className="pe-7s-cash"></i>Registration Fee : 20$
            </Row>            
            <Row>              
            <i className="pe-7s-culture"></i>Participants : Edison, Clifton & Jersey city Mandir
            </Row> */}
            </Grid>
          </div>
    </div>   

   
  </div>


);

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home/index.js